export default{
    applRefund:{
        btnState:{
            btn1:'取消',
            btn2:'保存并提交审核',
            btn3:'提交申请',
            btn4:'已收到货',
            btn5:'未收到货',
            btn6:'验收标准'
        },
        titleList:{
            title1:'订单信息',
            title2:'申请退款',
            title3:'规格：',
            title4:'不合格率在',
            title5:'% 及以内为正常收货；不合格率',
            title6:'%之间，实行补损；不合格率在 ',
            title7:'%之间，采取降价收货；不合格率大于',
            title8:'%，拒收或双方协议。',
            title9:'服务信息',
            title10:'为了更好的帮您解决问题，请上传图片，最多可上传6张图片，每张图片大小不超过5M，支持bmp,gif,jpg,png,jpeg格式文件',
            title11:'原支付方式返回',
            title12:'线上支付的订单退款金额原路返回支付账户，账期支付的订单退款金额在账期结算时自动扣除，线下支付的订单退款方式由买卖双方协商。',
            title13:'确认信息',
            title14:'元',
            title15:'请保持电话畅通，服务人员将及时与您联系！',
            title16:'元'
        },
        plachordels:{
            pla1:'请选择退货原因',
            pla2:'请输入5-50字的问题描述',
        },
        fromtitle:{
            from1:'订单编号：',
            from2:'下单时间：',
            from3:'商品总额：',
            from4:'运费金额：',
            from5:'订单金额：',
            from18:'支付金额：',
            from6:'商品名称',
            from7:'购买数量',
            from8:'货物状态：',
            from9:'退货原因：',
            from10:'图片信息：',
            from11:'问题描述：',
            from12:'退款方式：',
            from13:'商品申退金额：',
            from14:'运费申退金额：',
            from15:'申退总金额：',
            from16:'客户姓名：',
            from17:'手机号码：',
            // from18:'单价'
        },
       
        rulesMessage:{
            rule1:'请输入姓名',
            rule2:'请输入手机号码',
            rule3:'手机号码输入有误',
            rule4:'请选择退货原因',
            rule5:'请填写问题描述',
            rule6:'请输入5-50字的描述问题',
            rule7:'请输入运费申退金额',
            rule8:'请输入小数点后两位正确的金额',
            rule9:'运费申退金额不能大于',
            rule10:'请输入应退商品金额',
            rule11:'请输入小数点后两位正确的金额',
            rule12:'商品申退金额不能大于',
            rule13:'请输入应退总金额',
            rule14:'请选择活动资源',
            rule15:'请上传图片信息',
            rule16:'申请已提交，请等待售后审核',
            rule17:'线下支付不支持在线退款',

        }
    }
}